module.exports = {
    console: {
        log: function () {}
    },
    document: {
        body: {
            clientWidth: 1920,
            clientHeight: 1080,
            addEventListener: function () {},
            removeEventListener: function () {}
        }
    }
};
